import { FlexStack } from '~/components/atomic';
import { Favorite } from '~/assets/img/icons';
import * as S from './Card.styled';

interface CardProps {
  id: string;
  imageUrl: string;
  name?: string;
  rating?: number;
  review_count?: number;
  onClick?: () => void;
  imageRatio?: string;
  selected?: boolean;
}

export default function Card({
  id,
  imageUrl,
  name,
  rating,
  review_count,
  onClick,
  imageRatio = '150%',
  selected,
}: CardProps) {
  return (
    <S.Container id={id} onClick={onClick}>
      <FlexStack direction={'column'} spacing={4}>
        <S.ImageBox imageRatio={imageRatio} selected={selected}>
          <img src={imageUrl} alt='asset_motion' />
        </S.ImageBox>
        {name && (
          <FlexStack direction={'column'} spacing={4}>
            <S.TitleBox>
              <S.Title>{name}</S.Title>
            </S.TitleBox>
            {rating && review_count && (
              <S.ReviewBox>
                <S.IconBox>
                  <i>
                    <Favorite />
                  </i>
                </S.IconBox>
                <S.Review>
                  <span>{rating?.toFixed(1)}</span>
                  <span>
                    (
                    {review_count
                      ? review_count > 999
                        ? '999+'
                        : review_count
                      : ''}
                    )
                  </span>
                </S.Review>
              </S.ReviewBox>
            )}
          </FlexStack>
        )}
      </FlexStack>
    </S.Container>
  );
}
